"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorPage = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const documenter_ui_heading_1 = require("@teambit/documenter.ui.heading");
const error_page_module_scss_1 = __importDefault(require("./error-page.module.scss"));
/**
 * A component that shows an error page according to the error code
 */
function ErrorPage(_a) {
    var { code, title, className, children } = _a, rest = __rest(_a, ["code", "title", "className", "children"]);
    return (react_1.default.createElement("div", Object.assign({}, rest, { className: classnames_1.default(error_page_module_scss_1.default.errorPage, className) }),
        react_1.default.createElement(documenter_ui_heading_1.H1, { className: error_page_module_scss_1.default.title }, title),
        react_1.default.createElement("img", { alt: "error-image", className: error_page_module_scss_1.default.img, src: `https://static.bit.dev/harmony/${code}.svg` }),
        children));
}
exports.ErrorPage = ErrorPage;
//# sourceMappingURL=error-page.js.map